.#{$namespace}-select {
	$expand-color: $text-placeholder-color;
	$bg-color: $white-color;

	position: relative;
	display: inline-block;
	box-sizing: border-box;
	width: 100%;
	display: inline-flex;
	align-items: center;
	border: 1px solid $border-color;
	border-radius: 8px;
	background-color: #{$bg-color};
	min-height: $control-height;
	cursor: pointer;
	.select-inner {
		flex: 1;
		min-height: 100%;
		display: flex;
		align-items: center;
		padding-block: 0;
		padding-inline: calc($control-height * 0.45);
		gap: 3px;
		// 左侧前缀，跟 Input prefix 同一侧，不占 label 的 flex
		.prefix {
			display: flex;
			flex-shrink: 0;
			align-items: center;
		}
		// 内容区
		.select-label {
			flex: 1;
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			&::before {
				content: attr(data-placeholder);
				font-size: calc($font-size - 2px);
				color: $text-placeholder-color;
			}
			.label-item {
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: calc($font-size - 2px);
				color: $text-primary-color;
			}
			&.is-multiple {
				gap: 8px;
				.label-item {
					position: relative;
					padding: 2px 10px;
					background-color: color-token(info, light-8);
					.svg-icon {
						position: absolute;
						top: 0;
						right: 0;
						font-size: calc($font-size - 4px);
						&:hover {
							color: color-token(danger);
						}
					}
					&.is-collapse {
						background-color: color-token(info, light-7);
					}
				}
			}
		}
		// 旋转图标
		.select-skill {
			position: relative;
			display: flex;
			width: 20px;
			font-size: $font-size;
			.skill-item {
				display: flex;
				align-items: center;
				justify-content: center;
				.svg-icon {
					color: #{$expand-color};
				}
				&.expand-btn {
					.svg-icon {
						transform: rotate(0);
						transition: transform 0.3s ease-in-out;
					}
				}
				&.close-btn {
					position: absolute;
					inset: 0;
					background-color: #{$bg-color};
					opacity: 0;
					visibility: hidden;
					transition: opacity 0.3s ease-in-out;
					&:hover {
						.svg-icon {
							color: color-token(danger);
						}
					}
				}
			}
		}
	}
	// 展开 / 悬停
	&.is-focus,
	&:hover {
		.select-inner .select-skill .skill-item {
			&.close-btn {
				opacity: 1;
				visibility: visible;
			}
		}
		&:not(.is-disabled) {
			border-color: color-token(primary);
		}
	}
	&.is-focus {
		.select-inner .select-skill .skill-item {
			&.expand-btn .svg-icon {
				transform: rotate(180deg);
			}
		}
	}
	&.is-disabled {
		// 同 Input：禁用不改底，业务皮肤（white-color-3）才能跟未禁用态对齐
		cursor: not-allowed;
	}
	&--large {
		min-height: calc(#{$control-height} + 8px);
	}
	&--small {
		min-height: calc(#{$control-height} - 8px);
		font-size: calc(#{$font-size} - 2px);
	}
}

// 下拉面板。Select 走 Popper plain，盒子写在这里；业务覆盖 `.select-dropdown` 即可，不必打 is-plain / :has
.select-dropdown {
	// 跟 Popper 默认面板同一套，plain 把 Popper 盒子拆掉之后由这里补回来
	overflow: hidden; // 圆角要裁切选项 hover
	border-radius: 8px;
	background-color: $white-color; // Popper plain 是透明的，不写这里下拉没有底
	box-shadow: 0 0 1px 1px #{alpha-color($black-color, 12%)};
	// 折叠区域
	.dropdown-input {
		border-radius: 0;
		border-left-color: transparent;
		border-top-color: transparent;
		border-right-color: transparent;
		border-bottom-color: color-token(info);
		&.is-focus {
			border-bottom-color: color-token(primary);
		}
	}
	.select-dropdown-item {
		padding: 4px 8px;
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: calc($font-size - 2px);
		cursor: pointer;
		// 前缀
		.prefix {
			width: 20px;
			.#{$namespace}-svg {
				font-size: $font-size;
				opacity: 0;
			}
		}
		&:hover {
			color: color-token(primary);
			background-color: color-token(primary, light-8);
		}
		&.is-active {
			color: $white-color;
			background-color: color-token(primary);
			.prefix {
				.#{$namespace}-svg {
					opacity: 1;
				}
			}
		}
		&.is-disabled {
			cursor: not-allowed;
			color: $text-disabled-color;
		}
	}
	.select-dropdown-empty {
		padding: 8px;
		text-align: center;
		color: $text-placeholder-color;
		font-size: calc($font-size - 2px);
	}
}
